import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";
import { FormControl } from "@/components/ui/form";

// Radix SelectItem rejects empty values, so the "Unassigned" choice uses a
// sentinel that callers map back to empty/undefined on submit.
export const EMPLOYEE_UNASSIGNED = "__unassigned__";

interface EmployeeSelectProps {
  value: string;
  onChange: (value: string) => void;
  options: string[];
  // Shown (disabled) inside the dropdown when options is empty.
  emptyHint: string;
}

// EmployeeSelect is the shared person-assignment dropdown (service
// technicians, customer sales reps). It renders an "Unassigned" choice plus the
// given roster names.
export function EmployeeSelect({ value, onChange, options, emptyHint }: EmployeeSelectProps) {
  // Keep an existing assignment selectable even when it is no longer in
  // options (legacy free-text values, or a since-terminated employee), so an
  // edit dialog never silently misrepresents who is assigned.
  const effectiveOptions =
    value && value !== EMPLOYEE_UNASSIGNED && !options.includes(value)
      ? [value, ...options]
      : options;

  return (
    <Select onValueChange={onChange} value={value || EMPLOYEE_UNASSIGNED}>
      <FormControl>
        <SelectTrigger>
          <SelectValue placeholder="Select an employee" />
        </SelectTrigger>
      </FormControl>
      <SelectContent>
        <SelectItem value={EMPLOYEE_UNASSIGNED}>Unassigned</SelectItem>
        {effectiveOptions.map((name) => (
          <SelectItem key={name} value={name}>
            {name}
          </SelectItem>
        ))}
        {effectiveOptions.length === 0 && (
          <SelectItem value="__none-available__" disabled>
            {emptyHint}
          </SelectItem>
        )}
      </SelectContent>
    </Select>
  );
}
